var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pyb-text"},[_c('div',{class:_vm.size == 'big' ? 'big-text' : 'small-text'},[_vm._v(_vm._s(_vm.pybNum))]),_c('div',{staticClass:"iconfont icon-w_jinbi",class:_vm.size == 'big' ? 'big-icon' : 'small-icon'})])}
var staticRenderFns = []

export { render, staticRenderFns }